import { commonRequest } from '../apiSaga';

export const updateAddressSaga = function* ({ address, addressId }) {
  return yield commonRequest('updateAddressId', {
    body: address,
    parameters: { addressId },
  });
};
